
export default {
    when() {
        return document.querySelectorAll('.tab-toggle').length > 0;
    },

    tabs: [],

    mounted() {
        document.querySelectorAll('.tab-toggle').forEach((button) => {
            this.tabs.push(new Tab(button, button.dataset));
        });
    },

    destroy() {
        this.tabs.forEach((collapse) => {
            collapse.unbind();
        });
    },
};


class Tab {
    constructor(button, options = {}) {
        this.button = button;
        this.options = {
            container: button.dataset.container || '.tabs-container',
            navContainer: button.dataset.navContainer || '.tabs-toggle-container',
            target: button.dataset.target || button.href.split('#').slice(-1),
            ...options,
        };
        this.tab = document.getElementById(this.options.target);
        this.isVisible = this.tab.classList.contains('open');
        this.container = this.tab.closest(this.options.container);
        this.navContainer = this.button.closest(this.options.navContainer);


        this.bind();
    }

    bind() {
        this.button.addEventListener('click', (e) => this.handleClick(e), true);
    }

    handleClick(e) {
        e.preventDefault();
        e.stopImmediatePropagation();

        this.show();
    }

    show() {
        if (this.tab.classList.contains('open')) {
            return;
        }

        if (this.container.querySelectorAll('.tab.open')) {
            this.container.querySelectorAll('.tab.open').forEach((tab) => {
                tab.classList.remove('open');
                tab.setAttribute('aria-expended', false);
            });
        }

        if (this.navContainer.querySelectorAll('.tab-toggle.active')) {
            this.navContainer.querySelectorAll('.tab-toggle.active').forEach((toggle) => {
                toggle.classList.remove('active');
                toggle.setAttribute('aria-expended', false);
            });
        }

        this.button.classList.add('active');
        this.tab.classList.add('open');
        this.tab.setAttribute('aria-expended', true);

        // close all collapse
        document.body.dispatchEvent(new Event('collapseHideAll'));
    }

    unbind() {
        this.button.removeEventListener('click', (e) => this.handleClick(e));
    }
}
